export interface Bounds {
  northEast: { lat: number; lng: number }
  southWest: { lat: number; lng: number }
}

export interface Grid {
  bounds: Bounds
}

export function generateSnappedGrids(bounds: Bounds, multi = 1): Grid[] {
  // Adjusting the snapped bounds to extend past the original bounds if necessary
  const snappedNorthEast = {
    lat: Math.ceil(bounds.northEast.lat / multi) * multi,
    lng: Math.ceil(bounds.northEast.lng / multi) * multi,
  }
  const snappedSouthWest = {
    lat: Math.floor(bounds.southWest.lat / multi) * multi,
    lng: Math.floor(bounds.southWest.lng / multi) * multi,
  }

  // Calculate ranges based on adjusted snapped bounds
  const latRange = snappedNorthEast.lat - snappedSouthWest.lat
  const lngRange = snappedNorthEast.lng - snappedSouthWest.lng

  const grids: Grid[] = []

  for (let latIndex = 0; latIndex < latRange; latIndex += multi) {
    for (let lngIndex = 0; lngIndex < lngRange; lngIndex += multi) {
      const gridSouthWest = {
        lat: snappedSouthWest.lat + latIndex,
        lng: snappedSouthWest.lng + lngIndex,
      }
      const gridNorthEast = {
        lat: gridSouthWest.lat + multi,
        lng: gridSouthWest.lng + multi,
      }
      grids.push({
        bounds: {
          southWest: gridSouthWest,
          northEast: gridNorthEast,
        },
      })
    }
  }

  // Step 1: Calculate the center of the provided bounds
  const center = {
    lat: (bounds.northEast.lat + bounds.southWest.lat) / 2,
    lng: (bounds.northEast.lng + bounds.southWest.lng) / 2,
  }

  // Step 2-4: Sort grids based on their proximity to the center
  grids.sort((a, b) => {
    const aCenter = {
      lat: (a.bounds.northEast.lat + a.bounds.southWest.lat) / 2,
      lng: (a.bounds.northEast.lng + a.bounds.southWest.lng) / 2,
    }
    const bCenter = {
      lat: (b.bounds.northEast.lat + b.bounds.southWest.lat) / 2,
      lng: (b.bounds.northEast.lng + b.bounds.southWest.lng) / 2,
    }
    const distanceA = Math.sqrt(
      Math.pow(aCenter.lat - center.lat, 2) +
        Math.pow(aCenter.lng - center.lng, 2),
    )
    const distanceB = Math.sqrt(
      Math.pow(bCenter.lat - center.lat, 2) +
        Math.pow(bCenter.lng - center.lng, 2),
    )
    return distanceA - distanceB
  })

  return grids
}
